import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../helpers/Firebase';
import { servicePath } from '../../constants/defaultValues';
import { NotificationManager } from '../../components/common/react-notifications';
import {
    FORM_KPI_LCR_LIST,
    FORM_KPI_LCR_PROJECT,
    FORM_KPI_LCR_ARTICLE_TYPE,
    FORM_KPI_LCR_ACQUISITION_TYPE,
    FORM_KPI_LCR_CONTRACT_TYPE,
    FORM_KPI_LCR_COUNTRY_PROJECT,
    FORM_KPI_LCR_COUNTRY_LIST,
    FORM_KPI_LCR_ADD
} from '../actions';

import {
    FormKpiLcrListSuccess, 
    FormKpiLcrListError,
    FormKpiLcrProjectSuccess,
    FormKpiLcrProjectError,
    FormKpiLcrArticleTypeSuccess,
    FormKpiLcrArticleTypeError,
    FormKpiLcrAcquisitionTypeSuccess,
    FormKpiLcrAcquisitionTypeError,
    FormKpiLcrContractTypeSuccess,
    FormKpiLcrContractTypeError,
    FormKpiLcrCountryProjectSuccess,
    FormKpiLcrCountryProjectError,
    FormKpiLcrCountryListSuccess,
    FormKpiLcrCountryListError,
    FormKpiLcrAddSuccess,
    FormKpiLcrAddError
} from '../actions';

export function* watchFormKpiLcrList() {
    yield takeEvery(FORM_KPI_LCR_LIST, onFormKpiLcrList);
}

export function* watchFormKpiLcrProject() {
    yield takeEvery(FORM_KPI_LCR_PROJECT, onFormKpiLcrProject);
}

export function* watchFormKpiLcrArticleType() {
    yield takeEvery(FORM_KPI_LCR_ARTICLE_TYPE, onFormKpiLcrArticleType);
}

export function* watchFormKpiLcrAcquisitionType() {
    yield takeEvery(FORM_KPI_LCR_ACQUISITION_TYPE, onFormKpiLcrAcquisitionType);
}

export function* watchFormKpiLcrContractType() {
    yield takeEvery(FORM_KPI_LCR_CONTRACT_TYPE, onFormKpiLcrContractType);
}

export function* watchFormKpiLcrCountryProject() {
    yield takeEvery(FORM_KPI_LCR_COUNTRY_PROJECT, onFormKpiLcrCountryProject);
}

export function* watchFormKpiLcrCountryList() {
    yield takeEvery(FORM_KPI_LCR_COUNTRY_LIST, onFormKpiLcrCountryList);
}

export function* watchFormKpiLcrAdd() {
    yield takeEvery(FORM_KPI_LCR_ADD, onFormKpiLcrAdd);
}

function getToken(auth) {
    return new Promise((resolve, reject) => {
        const unsubscribe = auth.onAuthStateChanged(user => {
            user.getIdToken().then((token) => {
                unsubscribe();
                resolve(token);
            });
        }, reject);
    });
}

const onFormKpiLcrListAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'kpiLCR/list', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onFormKpiLcrProjectAsync = async () => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'kpiLCR/project', {
        method: 'GET', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token }
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { data: response };
};


const onFormKpiLcrArticleTypeAsync = async () => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath +'kpiLCR/articletype', {
        method: 'GET', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token }
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { data: response };
};

const onFormKpiLcrAcquisitionTypeAsync = async () => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'kpiLCR/acquisitiontype', {
        method: 'GET', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token }
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { data: response };
};

const onFormKpiLcrContractTypeAsync = async () => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'kpiLCR/contracttype', {
        method: 'GET', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token }
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { data: response };
};

const onFormKpiLcrCountryProjectAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'kpiLCR/countryproject', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onFormKpiLcrCountryListAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'kpiLCR/countrylist', {
        method: 'GET', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onFormKpiLcrAddAsync = async (data) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'kpiLCR/add', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(data.payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { message: true, data: response };
};

function* onFormKpiLcrList(data) {
    try {
        const response = yield call(onFormKpiLcrListAsync, data.payload);
        yield put(FormKpiLcrListSuccess(response.data));
    } catch (error) {
        yield put(FormKpiLcrListError(error));
    }
}

function* onFormKpiLcrProject(data) {
    try {
        const response = yield call(onFormKpiLcrProjectAsync, data);
        yield put(FormKpiLcrProjectSuccess(response.data));
    } catch (error) {
        yield put(FormKpiLcrProjectError(error));
    }
}

function* onFormKpiLcrArticleType(data) {
    try {
        const response = yield call(onFormKpiLcrArticleTypeAsync, data);
        yield put(FormKpiLcrArticleTypeSuccess(response.data));
    } catch (error) {
        yield put(FormKpiLcrArticleTypeError(error));
    }
}

function* onFormKpiLcrAcquisitionType(data) {
    try {
        const response = yield call(onFormKpiLcrAcquisitionTypeAsync, data);
        yield put(FormKpiLcrAcquisitionTypeSuccess(response.data));
    } catch (error) {
        yield put(FormKpiLcrAcquisitionTypeError(error));
    }
}

function* onFormKpiLcrContractType(data) {
    try {
        const response = yield call(onFormKpiLcrContractTypeAsync, data);
        yield put(FormKpiLcrContractTypeSuccess(response.data));
    } catch (error) {
        yield put(FormKpiLcrContractTypeError(error));
    }
}

function* onFormKpiLcrCountryProject(data) {
    try {
        const response = yield call(onFormKpiLcrCountryProjectAsync, data.payload);
        yield put(FormKpiLcrCountryProjectSuccess(response.data));
    } catch (error) {
        yield put(FormKpiLcrCountryProjectError(error));
    }
}

function* onFormKpiLcrCountryList(data) {
    try {
        const response = yield call(onFormKpiLcrCountryListAsync, data);
        yield put(FormKpiLcrCountryListSuccess(response.data));
    } catch (error) {
        yield put(FormKpiLcrCountryListError(error));
    }
}

function* onFormKpiLcrAdd(data) {
    try {
        const response = yield call(onFormKpiLcrAddAsync, data);
        yield put(FormKpiLcrAddSuccess(response.data));
    } catch (error) {
        yield put(FormKpiLcrAddError(error));
        NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
    }
}

export default function* rootSaga() {
    yield all([
        fork(watchFormKpiLcrList),
        fork(watchFormKpiLcrProject),
        fork(watchFormKpiLcrArticleType),
        fork(watchFormKpiLcrAcquisitionType),
        fork(watchFormKpiLcrContractType),
        fork(watchFormKpiLcrCountryProject),
        fork(watchFormKpiLcrCountryList),
        fork(watchFormKpiLcrAdd)
    ]);
}
